import { Box, SortingTable } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const TableBox = styled(Box)`
  position: relative;
  overflow: scroll;
  max-height: calc(100vh - 200px);
`;
const Table = styled(SortingTable)`
  th {
    z-index: auto;
  }

  th:first-child {
    padding-left: 0;
  }
`;

export default function IndexTable(props) {
  return (
    <TableBox>
      <Table stickyHeader {...props} />
    </TableBox>
  );
}
